"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icons = exports.Icon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _images = require("../../assets/images");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Icons = {
  FabricLogo: _images.FabricLogo,
  Overview: _images.Overview,
  XM: _images.XM,
  PIM: _images.PIM,
  OMS: _images.OMS,
  Offers: _images.Offers,
  LoyaltyManagement: _images.LoyaltyManagement,
  Subscriptions: _images.Subscriptions,
  Dropship: _images.Dropship,
  POS: _images.POS,
  Close: _images.Close,
  SkuLookUp: _images.SkuLookUp,
  ProductPerformance: _images.ProductPerformance,
  UserBehaviors: _images.UserBehaviors,
  RunningPromotions: _images.RunningPromotions,
  AssignedToMe: _images.AssignedToMe,
  Help: _images.Help,
  Copy: _images.Copy,
  CircleDownArrow: _images.CircleDownArrow,
  DownArrow: _images.DownArrow,
  UpCaret: _images.UpCaret,
  LeftArrow: _images.LeftArrow,
  RightArrow: _images.RightArrow,
  DownCaret: _images.DownCaret,
  RightCaret: _images.RightCaret,
  UpArrow: _images.UpArrow,
  Link: _images.Link,
  Search: _images.Search,
  Delete: _images.Delete,
  Info: _images.Info,
  Play: _images.Play,
  Import: _images.Import,
  Export: _images.Export,
  Add: _images.Add,
  Dots: _images.Dots,
  Edit: _images.Edit,
  GridView: _images.GridView,
  ListView: _images.ListView,
  Settings: _images.Settings,
  Radio: _images.Radio,
  RadioSelected: _images.RadioSelected,
  CheckboxSelected: _images.CheckboxSelected,
  Checkbox: _images.Checkbox,
  Notification: _images.Notification,
  CircleClose: _images.CircleClose,
  Customize: _images.Customize,
  Eye: _images.Eye,
  FabricLogoName: _images.FabricLogoName,
  Checkmark: _images.Checkmark,
  Cross: _images.Cross,
  Pay: _images.Pay,
  Analytics: _images.Analytics,
  Customer: _images.Customer,
  Member: _images.Member,
  CSR: _images.CSR,
  Calculator: _images.Calculator,
  Calendar: _images.Calendar,
  Lock: _images.Lock
};
exports.Icons = Icons;

const Icon = ({
  size,
  iconName,
  ...restProps
}) => {
  const IconComponent = Icons[iconName];
  return IconComponent ? /*#__PURE__*/_react.default.createElement(IconComponent, _extends({
    size: size
  }, restProps)) : null;
};

exports.Icon = Icon;
Icon.propTypes = {
  /**Icon Size */
  size: _propTypes.default.number,

  /**Name for Icon, and it's mandatory*/
  iconName: _propTypes.default.string.isRequired,

  /**Icon Width it's option when we use size*/
  width: _propTypes.default.number,

  /**Icon Height it's option when we use size*/
  height: _propTypes.default.number
  /**And its take other props of SVG*/

};